import React from 'react';
import Grid2 from '@thirdparty-framework/mui/material/Grid';
import dayjs from 'dayjs';
import { Alert, Typography } from '@mui/material';
import { DATE_FORMAT, useUserAccess } from '@ui-framework/index';
import { capitalCase, pascalCase } from 'case-anything';
import IconLibrary from '../IconLibrary';
import IconHeader from '../IconHeader';
import AiButton from '../ArtificalIntelligence/AiButton';

function HeaderCell({ label, value }) {
  return (
    <>
      <Typography variant="body1" fontWeight="bold" color="primary.main">
        {label}
      </Typography>
      <Typography
        component="span"
        variant="body1"
        fontWeight="bold"
        color="common.black">
        {value}
      </Typography>
    </>
  );
}

function SJHeader({ formData, ...props }) {
  const userAccess = useUserAccess();
  return (
    <Alert
      sx={{
        display: 'block',
        borderRadius: 1,
        ...(props.sx || {}),
      }}
      icon={false}
      severity="info">
      <Grid2 container alignItems="center">
        <Grid2 xs={6} md={2}>
          <IconHeader
            bgColor="primary.main"
            size={40}
            Icon={IconLibrary.ServiceJob}>
            Job
          </IconHeader>
        </Grid2>
        <Grid2 xs={6} md={2} textAlign="center">
          <AiButton formData={formData} userAccess={userAccess} />
        </Grid2>
        <Grid2 xs={6} md={2} textAlign="center">
          {formData?.serviceJobNumber && (
            <HeaderCell label="Job Number" value={formData?.serviceJobNumber} />
          )}
        </Grid2>
        <Grid2 xs={6} md={3} textAlign="center">
          {formData?.dispatchEvent && userAccess.isSP() ? (
            <HeaderCell
              label="Dispatch Response Status"
              value={capitalCase(pascalCase(formData?.dispatchEvent?.status))}
            />
          ) : (
            formData?.serviceJobStatus && (
              <HeaderCell
                label="Job Status"
                value={capitalCase(pascalCase(formData?.serviceJobStatus))}
              />
            )
          )}
        </Grid2>
        <Grid2 xs={6} md={2} textAlign="center">
          {formData?.dispatchEvent && userAccess.isSP() ? (
            <HeaderCell
              label="Received Date"
              value={dayjs(formData?.dispatchEvent?.sentAt).format(
                DATE_FORMAT.LONG_DATE,
              )}
            />
          ) : (
            formData?.serviceJobStatus && (
              <HeaderCell
                label="Job Status Date"
                value={dayjs(formData?.serviceJobStatusDate).format(
                  DATE_FORMAT.LONG_DATE,
                )}
              />
            )
          )}
        </Grid2>
      </Grid2>
    </Alert>
  );
}

export default SJHeader;
